import { BCMSRecord, useBCMSContext, useModel, useParams, useRoute } from "@bcm-dev/bcms-vite";
import { UIPrimaryButton } from 'components/ui/UIButton';
import Classes, { Card } from "model";
import React from 'react';
import { SVGAsset } from 'res';
import './styles.css';

/**
 * @function TurnOffCardView
 * @return {React.Component}
 * @exported true
 * @description The View that confirms the card is turned off
 */

export default function TurnOffCardView(props) {
  const controller = useBCMSContext();
  const { branding } = useModel();
  const navigate = useRoute();
  const defaultCard = branding.options.include_debit_chw23 !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const card = Card.initByID(cardID);

  const onContinue = () =>  {
    BCMSRecord.batch([
      Card.update({ ...card.record, isOn: false })
    ], controller, Classes);

    navigate(`/home/reportloststolen/callturnoffcardconfirm/${ cardID }`);
  }

  return(
    <div className="turn-off-card-view">
      <div className="framed-icon-container">
        <SVGAsset id="DocumentsAlertIcon" />
      </div>
      <p className="text-center">Your card will be turned off to prevent unauthorized purchases. Recurring payments will still occur.</p>
      <p className="text-center">Select Continue to turn the card off and report your missing card.</p>
      <div className="flex-container button-container">
        <UIPrimaryButton text="Continue" onClick={ onContinue }  />
      </div>
    </div>
  );
}